import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, Outlet } from "react-router";

import { useSession } from "@/auth/session-context";
import { Brand } from "@/components/brand";
import { TabNav } from "@/components/tab-nav";
import { paths } from "@/routes/paths";

import { UserMenu } from "./user-menu";

/**
 * Zona de plataforma (Punto), aparte del shell de la organización: se entra
 * desde el menú de usuario y no enseña datos de certificados de ninguna
 * organización.
 */
export const PlatformShell = () => {
  const { t } = useTranslation("platform");
  const { currentOrganization } = useSession();

  return (
    <div className="flex min-h-screen flex-col bg-muted-subtle">
      <header className="sticky top-0 z-10 border-b bg-background">
        <div className="mx-auto flex h-14 max-w-6xl items-center gap-4 px-4 md:px-8">
          <Link to={paths.home} className="shrink-0">
            <Brand className="h-5" />
          </Link>
          <Link
            to={paths.home}
            className="inline-flex items-center gap-1 text-sm text-muted-foreground underline underline-offset-4 hover:no-underline"
          >
            <ArrowLeft className="size-4" aria-hidden />
            {currentOrganization
              ? t("backTo", { organization: currentOrganization.name })
              : t("backToApp")}
          </Link>
          <span className="font-display text-lg font-semibold">
            {t("title")}
          </span>
          <div className="ml-auto">
            <UserMenu />
          </div>
        </div>
        <div className="mx-auto max-w-6xl px-4 md:px-8">
          <TabNav
            label={t("title")}
            className="border-b-0"
            items={[
              {
                label: t("tabs.organizations"),
                to: paths.platformOrganizations,
              },
              { label: t("tabs.support"), to: paths.platformSupport },
              { label: t("tabs.catalog"), to: paths.platformCatalog },
            ]}
          />
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
};
